export default "__VITE_ASSET__Dx6WxyOh__"